import { Box, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

const AdditionalInfoItem: FC<
  React.PropsWithChildren<AdditionalInfoItemProps>
> = ({ name, data }) => {
  return (
    <Box display='flex' flexDirection='row' gap={1} width='280px'>
      <Typography variant='body2' color='text.secondary'>
        {name}
      </Typography>
      <Typography
        variant='body2'
        color='text.primary'
        overflow='hidden'
        textOverflow='ellipsis'>
        {data}
      </Typography>
    </Box>
  );
};

export interface AdditionalInfoItemProps {
  name: string;
  data: ReactNode;
}

export default AdditionalInfoItem;
